import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { DragAndDropError, Icon, NotificationEnum, NotificationService } from '../../../global';
import { DataImportDialogConfig } from '../../../global/entities/data-import.entity';
import { NgIf } from '@angular/common';
import { MessageComponent } from '../../components/message/message.component';
import { ButtonComponent } from '../../components/buttons/button/button.component';
import { DragAndDropComponent } from '../../components/drag-and-drop/drag-and-drop.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'slm-data-import-container',
    templateUrl: 'data-import.container.html',
    imports: [NgIf, MessageComponent, ButtonComponent, DragAndDropComponent, TranslatePipe]
})
export class DataImportContainerComponent {
  private readonly notificationService = inject(NotificationService);

  public readonly icons = Icon;
  public exampleFileIsLoading = false;

  @Input() public notification: { message: string; isInnerHtml: boolean; type: NotificationEnum } = null;
  @Input() public data: DataImportDialogConfig = null;
  @Output() file = new EventEmitter<File>();

  public downloadTestFile() {
    if (this.exampleFileIsLoading) {
      return;
    }
    this.exampleFileIsLoading = true;
    this.data.exampleDownload().subscribe({
      next: () => this.notificationService.notify('MESSAGE.DOWNLOAD_SUCCESS'),
      error: () => this.exampleFileIsLoading = false,
      complete: () => this.exampleFileIsLoading = false
    });
  }

  public unauthorizedFileFormat(event: DragAndDropError) {
    this.notificationService.notify(event.error === 'type' ? 'MESSAGE.ONLY_EXCEL_SUPPORTED' : event.message, NotificationEnum.ERROR);
  }

  public selectedFile(file: File) {
    this.file.emit(file);
  }
}
